export enum Orientation {
  Portrait,
  Landscape,
  None,
  NonStandard,
  NarrowPortrait,
}
